module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/page-four.cb6962da.jpg";